import angular from 'angular';
import { GrillaConfigurationPanel } from '@alquilatucancha/backoffice-integration';

const moduleName = 'atc-reservation-rules';

angular.module(moduleName, []).directive('reservationRules', [
    'Backoffice',
    (Backoffice) => ({
        restrict: 'A',
        scope: {
            courtId: '@',
        },
        link: (_scope, el) => {
            Backoffice.renderComponent(el[0], GrillaConfigurationPanel, {
                court_id: _scope.courtId,
            });

            // Al destruirse, desmontar el root de React (evita fugas en body).
            _scope.$on('$destroy', () => {
                Backoffice.unmountComponent?.(el[0]);
            });
        },
    }),
]);

export default moduleName;
